module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "name": "HeadSort"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleClick($event)
      }
    }
  }, [_c('i', {
    class: _vm.cls
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b7213c6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue2-datatable-component/src/Table/HeadSort.vue
// module id = 1300
// module chunks = 2